/* Publish by EComposer at 2026-10-09 13:35:19*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qjytif5pf6"]=  window.__ectimmers["ecom-qjytif5pf6"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-qjytif5pf6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qjytif5pf6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wvwod83fcba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wvwod83fcba', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gofpci2xb69').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gofpci2xb69', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aiw7a6gdqw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aiw7a6gdqw', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}